import {REGULAR_CODE} from "../../config/app";
import DateUtils from "./DateUtils";

const digitUppercase = function (money) {
  let isNegative = money < 0;
  if (isNegative) {
    money = -money;
  }
  //汉字的数字
  let cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');
  //基本单位
  let cnIntRadice = new Array('', '拾', '佰', '仟');
  //对应整数部分扩展单位
  let cnIntUnits = new Array('', '万', '亿', '兆');
  //对应小数部分单位
  let cnDecUnits = new Array('角', '分', '毫', '厘');
  //整数金额时后面跟的字符
  let cnInteger = '整';
  //整型完以后的单位
  let cnIntLast = '元';
  //最大处理的数字
  let maxNum = 999999999999999.9999;
  //金额整数部分
  let integerNum;
  //金额小数部分
  let decimalNum;
  //输出的中文金额字符串
  let chineseStr = '';
  //分离金额后用的数组，预定义
  let parts;
  if (money == '') {
    return '';
  }
  money = parseFloat(money);
  if (money >= maxNum) {
    //超出最大处理数字
    return '';
  }
  if (money == 0) {
    chineseStr = cnNums[0] + cnIntLast + cnInteger;
    return chineseStr;
  }
  //转换为字符串
  money = money.toString();
  if (money.indexOf('.') == -1) {
    integerNum = money;
    decimalNum = '';
  } else {
    parts = money.split('.');
    integerNum = parts[0];
    decimalNum = parts[1].substr(0, 4);
  }
  //获取整型部分转换
  if (parseInt(integerNum, 10) > 0) {
    let zeroCount = 0;
    let IntLen = integerNum.length;
    for (let i = 0; i < IntLen; i++) {
      let n = integerNum.substr(i, 1);
      let p = IntLen - i - 1;
      let q = p / 4;
      let m = p % 4;
      if (n == '0') {
        zeroCount++;
      } else {
        if (zeroCount > 0) {
          chineseStr += cnNums[0];
        }
        //归零
        zeroCount = 0;
        chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
      }
      if (m == 0 && zeroCount < 4) {
        chineseStr += cnIntUnits[q];
      }
    }
    chineseStr += cnIntLast;
  }
  //小数部分
  if (decimalNum != '') {
    let decLen = decimalNum.length;
    for (let i = 0; i < decLen; i++) {
      let n = decimalNum.substr(i, 1);
      if (n != '0') {
        chineseStr += cnNums[Number(n)] + cnDecUnits[i];
      }
    }
  }
  if (chineseStr == '') {
    chineseStr += cnNums[0] + cnIntLast + cnInteger;
  } else if (decimalNum == '') {
    chineseStr += cnInteger;
  }
  if (isNegative) {
    return "负" + chineseStr;
  }
  return chineseStr;
};
/// 乘法函数，用来得到精确的乘法结果
const accMul = function(arg1,arg2){
  let m=0,s1=arg1.toString(),
    s2=arg2.toString();
  try{
    m+=s1.split(".")[1].length}catch(e){}
  try{
    m+=s2.split(".")[1].length}catch(e){}
  return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m)
};
//除法函数，用来得到精确的除法结果
const accDiv = function accDiv(arg1,arg2){
  let t1=0,t2=0,r1,r2;
  try{t1=arg1.toString().split(".")[1].length}catch(e){}
  try{t2=arg2.toString().split(".")[1].length}catch(e){}
  r1=Number(arg1.toString().replace(".",""));
  r2=Number(arg2.toString().replace(".",""));
  return (r1/r2)*pow(10,t2-t1);
};
//加法函数，用来得到精确的加法结果
const accAdd = function (arg1,arg2){
  let r1,r2,m;
  try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0}
  try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0}
  m=Math.pow(10,Math.max(r1,r2))
  return (arg1*m+arg2*m)/m;
};
//减法函数，用来得到精确的减法结果
const accSubtr = function (arg1,arg2){
  let r1,r2,m,n;
  try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0}
  try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0}
  m=Math.pow(10,Math.max(r1,r2));
//动态控制精度长度
  n=(r1>=r2)?r1:r2;
  return ((arg1*m-arg2*m)/m).toFixed(n);
};
//
const setNumberFormat = function (num, m) {
  let num1 = num.split('.')[0];
  let num2 = num.split('.')[1];
  let num20 = num2.slice(0, m);
  let num21 = num2.slice(m).replace(/0+$/, '');
  return num1 + '.' + num20 + num21
};
//将数字转换为金额字符串 结果带千分符 根据传入参数保留小数位
const formatData = function (s,n,m){
  if (s === null || s ==='' || s === undefined) return null;
  let flag = false;
  n = n > 0 && n <= 20 ? n : 2;
  m = m === undefined || m<0 || m > 20 || m > n ? n : m;
  if(isNaN(s)) return s;
  s = s+"";
  if (s[0] === '-') {
    s = s.substring(1);
    flag = true;
  }
  s = parseFloat(s.replace(/[^\d\.-]/g, ""));
  s=Math.round(accMul(s, Math.pow(10,(n))));
  s=s/(Math.pow(10,n));
  s=s.toString();
  if(s.indexOf('.') === -1){
    s=parseFloat(s).toFixed(n);
  }
  let l = s.split(".")[0].split("").reverse(), r = s.split(".")[1], t = "";
  for (let i = 0; i < l.length; i++) {
    t += l[i] + ((i + 1) % 3 === 0 && (i + 1) !== l.length ? "," : "");
  }
  let num = '';
  if(flag){
    num = '-' + t.split("").reverse().join("") + "." + r;
  } else {
    num = t.split("").reverse().join("") + "." + r
  }
  // 补0
  let len = num.split('.')[1].length;
  if(len < n) {
    num +=  '0'.repeat(len)
  }
  num = setNumberFormat(num, m);

  return num;
};
//将带千分符金额转换为数字
const formatStr = function(str){
  if (str === null){
    return null
  }
  str = str +'';
  return str.replace(/,/g,'')
};
//保留两位小数方法
const formatNumber = function(data){
  let value = Math.round(parseFloat(data) * 100) / 100;
  let d = value.toString().split(".");
  if (d.length === 1) {
    value = value.toString() + ".00";
    return value;
  }
  if (d.length > 1) {
    if (d[1].length < 2) {
      value = value.toString() + "0";
    }
    return value;
  }
};

/**
 */
const discriCard = (IDCard) =>{
  let errMessage = [];
  let reg = REGULAR_CODE.ID_NUMBER_REG;
  let yearData =  IDCard.slice(6,10);
  let  monthData =  IDCard.slice(10,12);
  let  dayData =  IDCard.slice(12,14);
  if (IDCard === '' || IDCard === null) {
    errMessage.push('请输入证照号码');
  } else if (!reg.test(IDCard)){
    errMessage.push('身份证号不合法');
  } else if (1900 > yearData || yearData > DateUtils.getYear(new Date())){
    errMessage.push('身份证号不合法');
  } else if ( 1 > monthData || monthData > 12){
    errMessage.push('身份证号不合法');
  } else if ( 0 > dayData || dayData > 31){
    errMessage.push('身份证号不合法');
  }
  if(errMessage.length > 0) {
    return {errMessage}
  }

  let birthday = yearData + '-' + monthData + '-' +dayData;
  let sex = parseInt(IDCard.substr(16, 1)) % 2 === 1 ? 0 : 1;
  let myDate = new Date();
  let month = myDate.getMonth() + 1;
  let day = myDate.getDate();
  let age = myDate.getFullYear() - yearData - 1;
  if (monthData < month || monthData === month && dayData <= day) {
    age++;
  }

  return {birthday, sex, age, errMessage}

};

/**
 * 获取UUId
 * @returns {string}
 */
const getUUID = () => {
  return 'xxxx-xxxx-xxxx-xxxx-xxxx'.replace(/[xy]/g, function(c) {
    let r = Math.random()*16|0, v = c === 'x' ? r : (r&0x3|0x8);
    return v.toString(16);
  });
};

/**
 * 获取字符串字节长度
 * @param val
 * @returns {number}
 */
const getStrByteLength = (val) => {
  if (!val) return 0;
  let str = new String(val);
  let bytesCount = 0;
  for (let i = 0 ,n = str.length; i < n; i++) {
    let c = str.charCodeAt(i);
    if ((c >= 0x0001 && c <= 0x007e) || (0xff60<=c && c<=0xff9f)) {
      bytesCount += 1;
    } else {
      bytesCount += 2;
    }
  }
  return bytesCount;
};


const isEmpty = (val) => {
  // null or undefined
  if (val == null) return true;

  if (typeof val === 'boolean') return false;

  if (typeof val === 'number') return !val;

  if (val instanceof Error) return val.message === '';

  switch (Object.prototype.toString.call(val)) {
    // String or Array
    case '[object String]':
    case '[object Array]':
      return !val.length;

    // Map or Set or File
    case '[object File]':
    case '[object Map]':
    case '[object Set]':
    {
      return !val.size;
    }
    // Plain Object
    case '[object Object]':
    {
      return !Object.keys(val).length;
    }
  }

  return false;
};

//小数转换百分比（0.1234  ->  12.34%）
const formatDecimalsToPercent = function(data){
  let value = Math.round(parseFloat(data)*100 * 100) / 100;
  let d = value.toString().split(".");
  if (d.length === 1) {
    value = value.toString() + ".00";
    return value;
  }
  if (d.length > 1) {
    if (d[1].length < 2) {
      value = value.toString() + "0";
    }
    return value;
  }
};

export default {
  digitUppercase,
  formatData,
  formatStr,
  formatNumber,
  formatDecimalsToPercent,
  discriCard,
  getUUID,
  getStrByteLength,
  isEmpty
}



// WEBPACK FOOTER //
// ./src/libs/utils/NumberUtils.js